/* @flow weak */
import * as actions from './actions'
import { Record } from '../transit'
import { List } from 'immutable'

const State = Record({
  location: null,
  storageLoaded: false,
  errors: new List(),
  settings: {},
  navigationVisible: false,
  navigationOverlayVisible: false,
}, 'app')

const appReducer = (state = new State(), action) => {
  // This is how we can handle all async actions rejections.
  if (action.type.endsWith('_ERROR')) {
    const errors = action.payload.errors || action.payload
    return state.set('errors', new List(errors))
  }

  switch (action.type) {
    case actions.APP_SET_LOCATION:
      return state.set('location', action.payload.location)

    case actions.SET_SCROLL_LOCATION:
      return state.set('navigationOverlayVisible', action.payload.location > 50)

    case actions.APP_STORAGE_LOAD:
      return state.set('storageLoaded', true)

    case actions.FETCH_SETTINGS_SUCCESS:
      return state.set('settings', action.payload.data)

    case actions.TOGGLE_NAVIGATION:
      return state.set('navigationVisible', !state.get('navigationVisible'))

    default:
      return state
  }
}

export default appReducer



// WEBPACK FOOTER //
// ./src/common/app/reducer.js